<script>
  export let img = {
    src: "",
    alt: "Unlabled",
  };

  export let label = "";
  export let clickfn = "";
  export let clickable = true;
  export let border = false;

  const addBorders = () => {
    if (!clickable) return;

    border = !border;
  };
</script>

<div class="card-container">
  <div class="card" on:click={addBorders} on:click={clickfn} class:border>
    {#if img.src}
      <img src={img.src} alt={img.alt} />
    {/if}

    <slot />
  </div>
  <div class="label">
    {label}
  </div>
</div>

<style>
  .card-container {
    display: flex;
    flex-direction: column;
  }

  .card {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, 0.15);
    padding: 1rem;
    border-radius: 1rem;
    flex-direction: column;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
    flex: 1;
  }

  img {
    width: 100%;
  }

  .border {
    border: 1px solid #fe5900;
  }

  .label {
    display: block;
    text-align: center;
    margin-top: 0.5rem;
    font-weight: 500;
    color: #333;
    text-transform: capitalize;
  }
</style>
